import { useEffect } from "react";
import Lenis from "lenis";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Ticker from "@/components/Ticker";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Cities from "@/components/Cities";
import Stats from "@/components/Stats";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Partner from "@/components/Partner";
import ContactForm from "@/components/ContactForm";
import AppDownload from "@/components/AppDownload";
import Footer from "@/components/Footer";
import BottomNav from "@/components/BottomNav";
import WelcomeModal from "@/components/WelcomeModal";

function App() {
  useEffect(() => {
    // Smooth momentum scroll only on non-touch (desktop). On mobile/touch use native
    // scrolling for a fast, jank-free experience — especially on low-end / slow networks.
    const isTouch = typeof window !== "undefined" &&
      (window.matchMedia("(pointer: coarse)").matches || "ontouchstart" in window);

    let lenis = null;
    let raf;
    if (!isTouch) {
      lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      const loop = (t) => {
        lenis.raf(t);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
    }

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          if (lenis) lenis.scrollTo(el, { offset: -80 });
          else {
            const y = el.getBoundingClientRect().top + window.scrollY - 72;
            window.scrollTo({ top: y, behavior: "smooth" });
          }
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      if (raf) cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      if (lenis) lenis.destroy();
    };
  }, []);

  return (
    <ThemeProvider>
      <div className="App font-body bg-azo-bg text-azo-text min-h-screen" style={{ overflowX: "clip" }}>
        <Toaster position="top-center" richColors />
        <Navbar />
        <main className="pb-40 lg:pb-0">
          <Hero />
          <Ticker />
          <Services />
          <HowItWorks />
          <Stats />
          <Cities />
          <Testimonials />
          <Partner />
          <FAQ />
          <AppDownload />
          <ContactForm />
        </main>
        <Footer />
        <BottomNav />
        <WelcomeModal />
      </div>
    </ThemeProvider>
  );
}

export default App;
